import { AuthorizationModel } from "@/commons/services/Authorization";

/**
 * リクエストヘッダー
 */
export default class RequestHeader {
  /**
   * リクエストヘッダーを作成する
   */
  public static createHeader() {
    return {
      "Content-Type": "application/json"
    };
  }

  /**
   * 認証情報を付与したリクエストヘッダーを作成する
   */
  public static createAuthorizationHeader(authorization: AuthorizationModel) {
    return {
      "Content-Type": "application/json",
      Authorization: authorization.accessToken
    };
  }
}
